import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import Img from 'react-image';
import styled from 'styled-components';
import ImageGallery from 'react-image-gallery';
import { formatColorToRGB } from '../../../../../Utils';
import PopUpWrapper from '../../../../../Components/PopUpWrapper';

const Wrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${rem(380)}, auto));
  grid-gap: 0rem;
`;

const InspirationCard = styled.div`
  margin: ${rem(8)};
  box-shadow: 0 ${rem(3)} ${rem(5)} 0 rgba(0, 0, 0, 0.16);
  padding: ${rem(4)};
  background-image: linear-gradient(
    to bottom,
    #f0f0f0,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff
  );
`;
const InspirationTitle = styled.div`
  color: #434245;
  font-size: ${rem(16)};
  font-weight: bold;
`;
const InspirationBody = styled.div`
  display: flex;
  margin-top: ${rem(8)};
`;

const ImageWrapper = styled.div`
  overflow: hidden;
  max-height: ${rem(175)};
  width: ${rem(250)};
`;

const ShadesWrapper = styled.div`
  margin-left: ${rem(16)};
`;

const ShadeWrapper = styled.div`
  background: ${props => props.color};
  margin-bottom: ${rem(8)};
  height: ${rem(50)};
  width: ${rem(124)};
  font-size: ${rem(12)};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

const Image = styled(Img)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${rem(175)};
  width: ${rem(250)};
  z-index: 2;
  cursor: pointer;
  transition: transform 0.5s;
  &:hover {
    transform: scale(1.1);
  }
`;

const DetailImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: ${rem(700)};
`;

const Centerer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const baseURL = process.env.REACT_APP_IMAGES_PREFIX;

class Inspirations extends React.Component {
  state = {
    selected: undefined,
  };

  render() {
    const { inspirations, onShadeSelect } = this.props;
    const { selected } = this.state;

    return (
      <Wrapper>
        <PopUpWrapper
          display={selected}
          message={selected && selected.name}
          onClose={() =>
            this.setState({
              selected: undefined,
            })
          }
          onEscClose={() =>
            this.setState({
              selected: undefined,
            })
          }
        >
          <Centerer>
            <DetailImageWrapper>
              {selected && (
                <ImageGallery
                  items={selected.images.map(image => ({
                    original: `${baseURL}/images/1200x0/${image.fullPath}`,
                    thumbnail: `${baseURL}/images/250x150/${image.fullPath}`,
                  }))}
                />
              )}
            </DetailImageWrapper>
          </Centerer>
        </PopUpWrapper>

        {inspirations.map(i => (
          <InspirationCard>
            <InspirationTitle>{i.name}</InspirationTitle>
            <InspirationBody>
              <ImageWrapper>
                <Image
                  onClick={() =>
                    this.setState({
                      selected: i,
                    })
                  }
                  src={[`${baseURL}/images/370x0/${i.titleImage}`]}
                  loader={<Loader color="#70af00" />}
                />
              </ImageWrapper>

              <ShadesWrapper>
                {i.shades.map(s => (
                  <ShadeWrapper
                    color={formatColorToRGB(s.color)}
                    onClick={() => onShadeSelect(s)}
                  >
                    {s.color_base_name}
                  </ShadeWrapper>
                ))}
              </ShadesWrapper>
            </InspirationBody>
          </InspirationCard>
        ))}
      </Wrapper>
    );
  }
}

Inspirations.propTypes = {
  inspirations: PropTypes.arrayOf({}),
  onShadeSelect: PropTypes.func,
};

Inspirations.defaultProps = {
  inspirations: [],
  onShadeSelect: () => {},
};

export default Inspirations;



// WEBPACK FOOTER //
// ./src/Containers/Buy/Catalog/Detail/Inspirations/index.jsx